import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Creative and engaging content for children and parents, focusing on playful activities and educational resources." 
          style={{ 
            width: '100%', 
            maxHeight: '400px', 
            objectFit: 'cover' 
          }} 
        />
        <p className="eyebrow">Lil Kate Ball · Where Fun Meets Learning</p>
        <h1>Welcome to Lil Kate Ball!</h1>
        <p className="lede">
          Discover a world of playful activities and educational resources designed for children and parents alike. Join us in making learning fun!
        </p>
        <div className="cta-row">
          <a href="/activities" target="_self">
            Explore Activities
          </a>
          <a href="/resources" target="_self" className="secondary">
            Access Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Engaging Activities</h2>
          <p>
            Dive into a variety of fun and interactive activities that spark creativity and promote learning in children of all ages.
          </p>
        </article>
        <article>
          <h2>Educational Resources</h2>
          <p>
            Access a wealth of resources tailored to support parents and educators in fostering a love for learning in young minds.
          </p>
        </article>
        <article>
          <h2>Community Connection</h2>
          <p>
            Join our community of parents and educators to share experiences, tips, and ideas that enhance the learning journey.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;